<template>
  <v-container fluid>
    <!-- Migas de pan -->
    <v-breadcrumbs class="pa-1 ma-1" :items="breadcrumbs" />
    <!-- Tarjeta de búsqueda -->
    <v-card outlined class="m-4">
      <v-card-title class="text-h6 font-weight-medium">
        <v-icon left color="primary" class="mr-2">mdi-magnify</v-icon>
        Búsqueda de membresías
      </v-card-title>
      <v-card-subtitle class="mb-4">
        Puedes buscar mediante el número de
        <strong>membresía</strong>, o el <strong>nombre(s) y apellido</strong> del
        <strong>titular</strong>.
      </v-card-subtitle>
      <v-card-text>
        <v-form @submit.prevent="Buscar">
          <v-row dense>
            <!-- Campo de búsqueda @keyup.enter="Buscar"-->
            <v-col cols="12" sm="6" md="4" lg="4">
              <v-text-field v-model="paramMembresia" label="Escribe aquí" outlined dense clearable class="col"
                prepend-inner-icon="mdi-magnify" 
                 @input="paramMembresia = toUpperCaseGeneral(paramMembresia)" />
            </v-col>

            <v-col>
              <v-btn color="azulfuerte" @click="Buscar" outlined dark>
                Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-row>
      <v-col v-for="(item, index) in membresias" :key="index" cols="12" md="6">
        <v-card outlined class="pa-4 elevation-5">
          <v-row justify="end">
            <!-- Chip de Estatus arriba a la izquierda -->
            <v-chip :color="item.Estatus === 'ACTIVO' && item.MontoUrgencias > 0 ? 'green darken-2' : 'red darken-2'"
              text-color="white" class="text-subtitle-1 px-4 py-2">
              <v-icon left small>
                {{ item.Estatus === 'ACTIVO' && item.MontoUrgencias > 0 ? 'mdi-check-circle' : 'mdi-alert-circle' }}
              </v-icon>
              <div v-if="item.Estatus === 'ACTIVO' && item.MontoUrgencias > 0">
                ACTIVA
              </div>
              <div v-else>
                SUSPENDIDA
              </div>
            </v-chip>
          </v-row>
          <!-- Título con ícono -->
          <v-card-title class="mb-1">
            <v-icon left class="mr-2">mdi-account</v-icon>
            {{ item.Titular }}
          </v-card-title>
          <v-card-subtitle class="mb-2 grey--text text--darken-1">
            Membresía: <b>{{ item.Id }}</b>
          </v-card-subtitle>
          <v-card-text>
            <!-- Plan -->
            <div class="mb-2">
              <v-icon left small class="mr-1">mdi-file-document-outline</v-icon>
              <strong>Plan:</strong> {{ item.Plan }}
            </div>

            <!-- Monto de urgencias -->
            <div class="mb-3">
              <v-icon left small class="mr-1">mdi-hospital</v-icon>
              <strong>Monto urgencias:</strong>
              <span class="font-weight-bold">
                {{ formatCurrency(item.MontoUrgencias) }}
              </span>
            </div>

            <!-- Beneficiarios -->
            <div v-if="item.Beneficiarios && item.Beneficiarios.length">
              <strong>Listado de beneficiarios:</strong>
              <v-list dense>
                <v-list-item v-for="(bene, bIndex) in item.Beneficiarios" :key="bIndex">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-row  no-gutters>
                      <!-- Nombre -->
                      <v-col cols="12" sm="6" class="font-weight-medium">
                        {{ bene.Nombres }} {{ bene.Apaterno }} {{ bene.Amaterno }}
                        <v-list-item-subtitle class="mt-1">
                          {{ bene.Parentesco || '' }}
                        </v-list-item-subtitle>
                      </v-col>

                      <!-- Botón -->
                      <v-col cols="12" sm="6" class="text-sm-right mt-2 mt-sm-0">
                        <v-btn
                          color="azulfuerte"
                          :disabled="item.MontoUrgencias === 0"
                          @click="urgenciaMembresia(item, bene)"
                          outlined
                          small
                        >
                          <v-icon left small>mdi-file</v-icon>
                          Nota ingreso
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </v-card-text>
          <!-- Texto importante -->
          <v-alert v-show="item.Estatus === 'ACTIVO' && item.MontoUrgencias > 0" type="info" class="mt-6 left" dense
            color="green lighten-3" text>
            <v-icon left color="green">mdi-card-account-details</v-icon>
            Puede validar la identidad del <strong>paciente</strong> con una <strong>identificación oficial</strong>.
          </v-alert>
        </v-card>
      </v-col>
      <v-col v-if="!membresias.length" class="text-center d-flex flex-column align-center justify-center" cols="12">
        <v-icon color="grey" size="64">mdi-account-off</v-icon>
        <h3 class="mt-3 grey--text text--darken-1">No se encontraron membresías</h3>
        <p class="grey--text">Verifica tu búsqueda o intenta más tarde.</p>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogUrgencia" max-width="60%" persistent>
      <v-card>
        <v-card-title>Se dará atencion médica de urgencia.
        </v-card-title>
          <v-card-subtitle>
          Se mostrará la <b>nota de ingreso correspondiente</b> 
          para ser firmada por el <b>Paciente</b> o <b>Titular</b>.
          </v-card-subtitle>
        <v-card-text>
          <atencionUrgenciaForm ref="urgenciaForm" :urgencia="this.urgencia" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogUrgencia = false">Cancelar</v-btn>
          <v-btn color="primary" @click="crearUrgencia">Generar nota de ingreso</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Modal para ver PDF -->
    <v-dialog v-model="showPdf" max-width="80%" persistent>
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>Nota de ingreso</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarvistapdf">
            <v-icon>mdi-close</v-icon>
          </v-btn> 
        </v-toolbar>
        <v-card-text style="height: 80vh; padding: 0;">
          <iframe
            v-if="isPdfReady"
            :src="pdfUrl"
            width="100%"
            height="90%"
            style="border: none;"
          ></iframe>
          <div v-else>
          <div class="d-flex justify-center align-center fill-height flex-column">
            <v-progress-circular indeterminate color="primary" size="48" />
            <div class="mt-2 grey--text">Cargando nota de ingreso, espera un momento...</div>
          </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import formatFecha from '@/mixins/formatFecha';
import upperCase from '@/mixins/upperCase';
import atencionUrgenciaForm from '@/components/atencionUrgenciaForm.vue';
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  mixins: [formatFecha, upperCase],
  components: {
    atencionUrgenciaForm
  },
  mounted() {
    this.paramMembresia = this.$route.params.mem || '';
    if (this.paramMembresia) {
      this.getMembresias()
    }
  },
  created(){
    if (!this.getNombresApaterno) {
      this.$store.dispatch('cargarNombresApaterno'); // tu acción que llena el state
    }
  },
  data() {
    return {
      showPdf: false,
      pdfUrl: null,
      isPdfReady: false,
      reintentosPdf: 0, // contador de intentos
      maxReintentos: 2, // límite de intentos
      dialogUrgencia: false,
      urgencia: {
        Contrato: null,
        FechaIngreso: new Date().toISOString().split('T')[0],
        Paciente: null,
        Edad: null,
        Parentesco: null,
        IdBeneficiado: null,
        Titular: null,
        Plan: null,
        Colectivo: null,
        FecVigencia: null,
        // Total: null,
        // Diagnostico: null,
        // Descripcion: null,
        // MontoMaxUrgencias: 0,
        // FechaFactura: null,
        // Factura: null,
        // Tipo: null,
        NombreHospital: this.getNombresApaterno
      },
      beneficiarioSeleccionado: [],
      paramMembresia: '',
      membresias: [],
    };
  },
  computed: {
    ...mapGetters(['getNombresApaterno']),
    breadcrumbs() {
      return [
        { text: 'Inicio', disabled: true, href: '/' },
        { text: this.$route.meta.title || this.$route.name, disabled: true }
      ];
    },
    mem() {
      return this.$route.params.mem;
    }
  },
  methods: {
    cerrarvistapdf(){
      this.pdfUrl = null
      this.showPdf = false
      this.paramMembresia =''
      this.getMembresias()
    },
  async abrirPdf(idArchivo) {
    this.isPdfReady = false;
    this.pdfUrl = `${process.env.VUE_APP_BUCKETFORMATOS}urgencia/IngresoHospital?Id=${encodeURIComponent(idArchivo)}`;
    this.showPdf = true;

    try {
      await axios.get(this.pdfUrl);
      this.isPdfReady = true;
      this.reintentosPdf = 0; // reiniciar el contador si carga
    } catch (error) {
      console.warn(`Reintento #${this.reintentosPdf + 1}: PDF aún no disponible`);

      this.reintentosPdf++;
      if (this.reintentosPdf < this.maxReintentos) {
        setTimeout(() => this.abrirPdf(idArchivo), 3000);
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          html: 'No se pudo cargar la nota de ingreso después de varios intentos. Intenta más tarde.',
          confirmButtonText: 'Aceptar',
        });
        this.showPdf = false;
        this.pdfUrl = null;
        this.reintentosPdf = 0;
      }
    }
  },
    getNombreHospital() {
      return this.getNombresApaterno
    },
    formatCurrency(amount) {
      return this.$formatCurrency(amount);
    },
    urgenciaMembresia(membresia, beneficiario) {
      this.dialogUrgencia = true
      this.urgencia.Contrato = membresia.Id
      this.urgencia.IdBeneficiado = beneficiario.Id
      this.urgencia.Paciente = `${beneficiario.Nombres} ${beneficiario.Apaterno} ${beneficiario.Amaterno}`
      //this.urgencia.MontoMaxUrgencias = monto
      this.urgencia.Edad = beneficiario.Edad
      this.urgencia.Parentesco = beneficiario.Parentesco
      this.urgencia.NombreHospital = this.getNombreHospital()
      //this.urgencia.Total = 0
      this.urgencia.Titular = membresia.Titular
      this.urgencia.Plan = membresia.Plan
      this.urgencia.FecVigencia = membresia. FecVigenciaFormat
      this.urgencia.Colectivo = membresia.Colectivo

    },
    crearUrgencia() {
      /*
       const form = this.$refs.urgenciaForm.$refs.formUrgencia;
       if (form && !form.validate()) return;
      const datos = this.$refs.urgenciaForm.getUrgencia();
      datos.Paciente = this.urgencia.NombreBeneficiado
      datos.Edad = this.urgencia.Edad
      datos.Parentesco = this.urgencia.Parentesco
      datos.NombreHospital = this.getNombreHospital()
      datos.Total = 0
      */

      this.$http.post(`membresia/urgencia`, this.urgencia)
        .then(response => {
            if (response.status === 200) {
              //window.open(`${process.env.VUE_APP_BUCKETFORMATOS}urgencia/IngresoHospital?Id=${response.data}.pdf`, '_blank');
               this.abrirPdf(response.data)
            }
            /*
          this.$swal.fire({
            position: 'center',
            html: `Urgencia registrada correctamente.<br/><br/>
                   Se mostrará la <b>nota de ingreso correspondiente</b>, puedes imprimirla y guardarla.<br/><br/><br/>
                        Membresia:<b> ${this.urgencia.Contrato} </b><br/>
                        ID: <b>${response.data}</b><br/>
                        `,
            icon: 'success',
            confirmButtonText: 'DE ACUERDO',
            confirmButtonColor: '#C8E6C9',
            showCloseButton: false,
            showConfirmButton: true,
            backdrop: false
          }).then(result => {
            if (result.isConfirmed) {
              window.open(`${process.env.VUE_APP_BUCKETFORMATOS}urgencia/IngresoHospital?Id=${response.data}.pdf`, '_blank');
              /*
              const url = `${process.env.VUE_APP_BUCKETFORMATOS}urgencia/IngresoHospital?Id=${response.data}.pdf`;
              fetch(url)
                .then(res => {
                  if (!res.ok) throw new Error('Archivo no encontrado');
                  return res.blob();
                })
                .then(blob => {
                  const url = window.URL.createObjectURL(blob);
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', `Nota_ingreso_medicover_${response.data}.pdf`);
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                  window.URL.revokeObjectURL(url);
                })
                .catch(err => {
                  console.error('Error al descargar:', err);
                  this.$swal.fire('Error', 'No se pudo descargar el archivo.', 'error');
                });
             
            }
          });
        })
        .catch((err) => {
          let mensajeError = 'Ups, tuvimos un error no esperado. <b>Intenta más tarde</b>.';

          if (err.response) {
            mensajeError = err.response.data?.mensaje
          }

          this.$swal.fire({
            position: 'center',
            html: mensajeError,
            icon: 'error',
            confirmButtonText: 'Cerrar',
            showCloseButton: true,
            showConfirmButton: true,
            backdrop: false
          });*/
        }).catch(() => {         
          let mensajeError = 'Ups, tuvimos un error no esperado. <b>Intenta más tarde</b>.';
          this.$swal.fire({
            position: 'center',
            html: mensajeError,
            icon: 'error',
            confirmButtonText: 'Cerrar',
            showCloseButton: true,
            showConfirmButton: true,
            backdrop: false,
            customClass: {
                confirmButton: 'v-btn v-btn--contained theme--light v-size--default boton-vuetify',
                closeButton: 'v-btn boton-close'
            },
          })
        })
        .finally(() => {
          //this.paramMembresia = ''
          //this.getMembresias()
        });


      this.dialogUrgencia = false;
    },
    Buscar() {
      this.getMembresias()
    },
    getMembresias() {
      this.$http.get(`membresia/buscaMembresia?qry=${this.paramMembresia || null}`)
        .then(response => {
          if (response.status === 200) {
            if (response.data) {
              this.membresias = response.data
            }
          }
        })
        .catch(() => {
        });
    }
  },
};
</script>
